import axios from 'axios';

// Use relative URL - will be proxied by nginx to backend
// This is the proper architecture: Frontend -> Nginx -> Backend (internal)
const API = '/api';

console.log('🔗 Using nginx proxy for API calls to:', API);

// Create axios instance with default config
const api = axios.create({
  baseURL: API,
  timeout: 10000,
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('exled_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle auth errors
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    
    // If error is 401 and we haven't tried to refresh token yet
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      
      // Try to get a fresh token
      try {
        const username = localStorage.getItem('exled_username');
        const password = localStorage.getItem('exled_password');
        
        if (username && password) {
          const response = await axios.post(`${API}/auth/login`, {
            username: username,
            password: password
          });
          
          const { token, user } = response.data;
          
          // Update stored token
          localStorage.setItem('exled_token', token);
          localStorage.setItem('exled_user', JSON.stringify(user));
          
          // Retry original request with new token
          originalRequest.headers.Authorization = `Bearer ${token}`;
          return api(originalRequest);
        }
      } catch (refreshError) {
        // If refresh fails, clear auth but don't force redirect during messaging or when already on login page
        localStorage.removeItem('exled_user');
        localStorage.removeItem('exled_token');
        localStorage.removeItem('exled_username');
        localStorage.removeItem('exled_password');

        // Only redirect to login if not already on login page and not in messaging operation
        if (!window.location.pathname.includes('/messages') &&
            !window.location.pathname.includes('/login')) {
          window.location.href = '/login';
        }

        return Promise.reject(refreshError);
      }
    }
    
    return Promise.reject(error);
  }
);

export default api;